const lib = require('./lib/main');
const get = lib.getSynonyms;
module.exports = { get }